var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2523_22016)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99309 2.34835C7.41378 2.34835 6.8582 2.57848 6.44857 2.98812C6.03893 3.39775 5.8088 3.95334 5.8088 4.53265V6.17086C5.8088 6.46052 5.69374 6.73831 5.48892 6.94313C5.2841 7.14794 5.00631 7.26301 4.71666 7.26301C4.427 7.26301 4.14921 7.14794 3.94439 6.94313C3.73958 6.73831 3.62451 6.46052 3.62451 6.17086V4.53265C3.62451 3.37403 4.08477 2.26286 4.90404 1.44359C5.72331 0.624323 6.83447 0.164063 7.99309 0.164062C9.15172 0.164063 10.2629 0.624323 11.0821 1.44359C11.9014 2.26286 12.3617 3.37403 12.3617 4.53265V6.17086C12.3617 6.46052 12.2466 6.73831 12.0418 6.94313C11.837 7.14794 11.5592 7.26301 11.2695 7.26301C10.9799 7.26301 10.7021 7.14794 10.4973 6.94313C10.2925 6.73831 10.1774 6.46052 10.1774 6.17086V4.53265C10.1774 3.95334 9.94726 3.39775 9.53762 2.98812C9.12799 2.57848 8.5724 2.34835 7.99309 2.34835Z",
    fill: "#605D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98633 7.26224C1.98633 6.82776 2.15893 6.41107 2.46615 6.10385C2.77338 5.79662 3.19006 5.62402 3.62455 5.62402H12.3617C12.7962 5.62402 13.2129 5.79662 13.5201 6.10385C13.8273 6.41107 13.9999 6.82776 13.9999 7.26224V13.8151C13.9999 14.2496 13.8273 14.6663 13.5201 14.9735C13.2129 15.2807 12.7962 15.4533 12.3617 15.4533H3.62455C3.19006 15.4533 2.77338 15.2807 2.46615 14.9735C2.15893 14.6663 1.98633 14.2496 1.98633 13.8151V7.26224Z",
    fill: "#605D64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62769 10.539C6.62769 10.9011 6.77152 11.2483 7.02754 11.5043C7.28356 11.7604 7.6308 11.9042 7.99287 11.9042C8.35494 11.9042 8.70218 11.7604 8.9582 11.5043C9.21422 11.2483 9.35805 10.9011 9.35805 10.539C9.35805 10.1769 9.21422 9.8297 8.9582 9.57368C8.70218 9.31766 8.35494 9.17383 7.99287 9.17383C7.6308 9.17383 7.28356 9.31766 7.02754 9.57368C6.77152 9.8297 6.62769 10.1769 6.62769 10.539Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2523_22016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.d76e00de9afc35ea3bcd70b9e3f5410d.svg";
export { ForwardRef as ReactComponent };